<header class="bg-(--bg-color) p-4 md:p-6 flex justify-between items-center border-b border-[#DAE1E4]
         transition-all duration-300 flex-wrap md:flex-nowrap">

  <!-- Left Section -->
  <div class="flex items-center gap-3 w-full md:w-auto justify-between md:justify-start mb-2 md:mb-0">
    <button class="lg:hidden text-(--brand-primary) text-2xl cursor-pointer" (click)="toggleSidebar.emit()"
      aria-label="Toggle sidebar">
      ☰
    </button>

    <h2 class="font-semibold leading-8 text-xl md:text-2xl text-(--text-primary) truncate">
      {{ headerTitle | translate}}
    </h2>
  </div>

  <!-- Right Section -->
  <div *ngIf="showRightSection"
    class="flex items-center gap-3 sm:gap-4 relative w-full md:w-auto justify-end md:justify-normal">

    <!-- Notifications -->
    <div *ngIf="showNotifications" class="relative h-9 w-9 sm:h-10 sm:w-10 bg-white shadow-[0px_2px_6px_0px_#003FB51A]
             rounded-full flex items-center justify-center cursor-pointer hover:opacity-80" (click)="navToNotifications()">
      <div class="bg-(--color-error) w-2 h-2 rounded-full absolute top-2 right-3 rtl:left-3 rtl:right-auto"></div>
      <img src="assets/icons/notification.svg" [alt]="'HEADER.NOTIFICATION_ALT' | translate"
        class="transition-transform duration-300 w-4 sm:w-5" />
    </div>

    <!-- Profile -->
    <div class="bg-white rounded-full p-1 shadow-[0px_2px_6px_0px_#003FB51A] text-(--text-secondary) cursor-pointer"
      [ngStyle]="{
        border: dropdownOpen ? '0.5px solid var(--brand-primary)' : '0.5px solid white'
      }" (click)="toggleDropdown(); $event.stopPropagation()">

      <div class="flex items-center gap-2 sm:gap-3 rtl:flex-row-reverse">

        <!-- Profile Image / Initials -->
        <div class="bg-(--bg-color) rounded-full w-7 h-7 sm:w-8 sm:h-8 text-xs sm:text-sm leading-[22px] font-semibold
                 flex items-center justify-center overflow-hidden">
          <ng-container *ngIf="user.profileImage; else showInitials">
            <img [src]="user.profileImage" [alt]="'HEADER.PROFILE_ALT' | translate"
              class="w-full h-full object-cover rounded-full" />
          </ng-container>
          <ng-template #showInitials>{{ user.initials }}</ng-template>
        </div>

        <!-- Username -->
        <p class="hidden sm:block text-generic truncate max-w-[200px] sm:max-w-none">
          {{ 'HEADER.GREETING' | translate:{ name: user.name } }}
        </p>

        <!-- Arrow Icon -->
        <img src="assets/icons/arrow-down.svg" [alt]="'HEADER.ARROW_ALT' | translate"
          class="w-3 h-3 rtl:rotate-180 transition-transform duration-300 mr-1" [ngStyle]="{
            transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s'
          }" />
      </div>
    </div>

    <!-- Dropdown -->
    <div *ngIf="dropdownOpen"  (click)="$event.stopPropagation()" class="bg-white shadow-(--shadow-input) p-3 sm:p-4 rounded-2xl mt-2 flex flex-col absolute top-10 w-[200px] sm:w-2xs
             z-10 transition-all duration-300" [ngClass]="{ 'right-0 rtl:left-0 rtl:right-auto': true }">

      <ng-container *ngFor="let option of dropdownOptions; let last = last">
        <button class="dropdown-btn text-(--text-primary)" [ngClass]="{ 'border-b border-[#DAE1E4]': !last }"
          (click)="handleOptionClick(option)">
          <img *ngIf="option.iconPath" [src]="option.iconPath" [alt]="option.label | translate" class="w-6 h-6"/>
          {{ option.label | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</header>